import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  orderPreferencesContainer: {
    display: 'flex',
    flex: 1,
    padding: '16px 24px',
    '@media (max-width: 640px)': {
      padding: '0px',
    },
    backgroundColor: theme.evPalette.charcoal[100],
  },
  orderPreferencesPaper: {
    display: 'flex',
    width: '100%',
    borderRadius: 0,
    flexDirection: 'column',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
      borderRadius: '4px',
    },
  },
  tabsContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  tabsContainerSkeleton: {
    height: '40px',
    width: '313px',
    padding: '10px',
    borderBottom: `1px solid ${theme.evPalette.charcoal[300]}`,
    borderRight: `1px solid ${theme.evPalette.charcoal[300]}`,
    '@media (max-width: 640px)': {
      borderRight: '0px',
      width: '100%',
    },
  },
  indicator: {
    left: 0,
    backgroundColor: theme.evPalette.ocean[600],
  },
  tabElement: {
    borderBottom: `1px solid ${theme.evPalette.charcoal[300]}`,
    borderRight: `1px solid ${theme.evPalette.charcoal[300]}`,
    textTransform: 'none',
    flex: 1,
    '&>.myev-MuiTab-wrapper': {
      alignItems: 'flex-start',
    },
    '&.Mui-selected': {
      borderRight: '0px',
      color: theme.evPalette.ocean[700],
    },
    '&:hover': {
      backgroundColor: theme.evPalette.ocean[100],
    },
    '@media (max-width: 640px)': {
      borderRight: '0px',
      maxWidth: '100%',
    },
  },
  tabElementSkeleton: {
    height: '20px',
    width: '293px',
    borderRadius: '6px',
    '@media (max-width: 640px)': {
      borderRight: '0px',
      width: '100%',
    },
  },
  fillerGrid: { display: 'flex', flex: 1, borderRight: `1px solid ${theme.evPalette.charcoal[300]}` },
  pageContainer: {
    display: 'flex',
    flex: 1,
  },
  pageContainerSkeleton: {
    display: 'flex',
    flexDirection: 'column',
  },
  pageContainerRetry: {
    margin: 0,
  },
  pageContainerElements: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'fit-content',
    padding: '24px',
    gap: '16px',
    borderBottom: `1px solid ${theme.evPalette.charcoal[300]}`,
    '&.endBox': {
      borderBottom: '0px',
    },
  },
}));
